import { CloseIcon } from '@components/interface/Icons'
import { useLanguage } from '@context/LanguageContext'
import { cx } from '@utils/cx'
import styles from './ExitGameButton.module.css'

/**
 * Exit button for game screens.
 *
 * @param {Object} props
 * @param {Function} props.onClick - Handler called when button is clicked
 * @param {string} [props.className] - Additional CSS class for positioning overrides
 */
function ExitGameButton ({ onClick, className = '' }) {
  const { t } = useLanguage()

  return (
    <button
      type='button'
      className={cx(styles.exitBtn, className)}
      onClick={onClick}
      aria-label={t.shared.access.game.exitButton}
      title={t.shared.access.game.exitTooltip}
    >
      <CloseIcon size={24} stroke={2} aria-hidden='true' />
      <span className='sr-only'>{t.shared.access.game.exitTooltip}</span>
    </button>
  )
}

export default ExitGameButton
